module.exports = __webpack_public_path__ + "static/media/Roadside-Assistance.84fd5ad3.jpg";